import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { catchError, Observable } from 'rxjs';

import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { MediaTypeEnum } from '../../../../Basic/enums/media-type.enum';
import { OEmbedRichResponseModel } from '../../../../../api/oembed/models/oembed-rich-response.model';
import { OEmbedApi } from '../../../../../api/oembed/oembed.api';
import { AgprComponentStyleEnum } from '../../../../Basic/enums/social-analysis-types.enum';
import { Mention } from '../../../../Mentions/models/mention';
import { messageSeverityEnum } from '../../../../Misc/enums/message-severity.enum';


@Component({
    selector: 'agpr-social-post-display',
    templateUrl: './social-post-display.component.html',
    styleUrls: ['./social-post-display.component.scss'],
    standalone: false
})
export class SocialPostDisplayComponent implements OnInit {

    @Input() mention: Mention;

    socialEmbedURL: string;
    socialEmbedCode: SafeHtml;
    noContentToDisplay: boolean = false;

    isSocialFrameLoaded: boolean = false;

    iframeTitle: string;

    readonly endOfUrl = /([^\/]+$)/g;
    readonly componentStyle = AgprComponentStyleEnum;
    readonly messageSeverities = messageSeverityEnum;

    constructor(
        private sanitizer: DomSanitizer,
        private oembedApi: OEmbedApi,
        private localizationService: LocalizationService
    ) {}

    ngOnInit(): void {
        this.socialEmbedCode = undefined;
        this.socialEmbedURL = this.mention.getEmbedURL();

        this.iframeTitle = this.localizationService.transform(
            'Social.postViewer.iframeTitle',
            { media: this.localizationService.transform(`MediaType.${this.mention.mediaType.id}`)}
        );

        if (!this.socialEmbedURL) {
            this.getOEmbedCode();
        }
    }

    socialFrameLoaded(): void {
        requestAnimationFrame(() => {
            this.isSocialFrameLoaded = true;
        });
    }

    /**
     * Requests embedable content from social networks
     */
    private getOEmbedCode(): void {
        if (!this.mention.mediaType.isSocial || !this.mention.url) {
            return;
        }

        let request: Observable<OEmbedRichResponseModel>;
        switch (this.mention.mediaType.id) {
            // TODO: facebook doesn't work right now because of a CORS problem
            // case MediaTypeEnum.FACEBOOK:
            //     request = this.oembedApi.facebook(this.mention.url);
            //     break;
            case MediaTypeEnum.TWITTER:
                request = this.oembedApi.twitter(this.mention.url);
                break;
            case MediaTypeEnum.TIKTOK:
                const videoId = this.mention.url.match(this.endOfUrl)?.[0];

                // eslint-disable-next-line max-len
                const tiktokBlock: any = `<blockquote class="tiktok-embed" cite="${this.mention.url}" data-video-id="${videoId}" style="max-width: 605px;min-width: 325px;" >
                    <section>
                    </section>
                </blockquote>
                <script async src="https://www.tiktok.com/embed.js"></script>`;

                this.socialEmbedCode = this.sanitizer.bypassSecurityTrustHtml(tiktokBlock);
                break;
            case MediaTypeEnum.INSTAGRAM:
                const instagramBlock: any = `<blockquote class="instagram-media" data-instgrm-captioned="" data-instgrm-version="13">
                    <a href="${this.mention.url}" target="_blank">Open on Instagram</a>
                    </blockquote><script src="//www.instagram.com/embed.js"></script>`;

                this.socialEmbedCode = this.sanitizer.bypassSecurityTrustHtml(instagramBlock);
                break;
            case MediaTypeEnum.BLUESKY:
                request = this.oembedApi.bluesky(this.mention.url);
                break;
            // @TODO: REMOVE when doing NEP-10761
            case MediaTypeEnum.REDDIT:
                const redditBlock = `<blockquote class="reddit-embed-bq" style="height:500px" data-embed-height="500">
                    <a href="${this.mention.url}">Reddit Post</a>
                    </blockquote>
                    <script async src="https://embed.reddit.com/widgets.js" charset="UTF-8"></script>`;
                this.socialEmbedCode = this.sanitizer.bypassSecurityTrustHtml(redditBlock);
                break;
        }

        if (request) {
            request.pipe(
                catchError(err => {
                    this.noContentToDisplay = true;
                    throw err;
                })
            ).subscribe((response) => {
                this.socialEmbedCode = this.sanitizer.bypassSecurityTrustHtml(response.html);
            });
        }
    }
}
